// node modules
import React, { FC, useCallback } from 'react';
import { observer } from 'mobx-react';
// ui library
import { View } from '@upstox/upstox-ui';
// modules
import { useStore } from 'modules/Stores';
// typings
import { Props } from './typings';
// styles
import * as css from './styles';

const OptionChainOIBarCell: FC<Props> = props => {
  const { instrumentKey, isCall } = props;
  const { maxOI } = useStore('OptionChainStore');
  const { getOptionParamValueWithInstrumentKey } = useStore('LiveDataStore');
  const openInterest = getOptionParamValueWithInstrumentKey(
    instrumentKey,
    'openInterest',
  );

  const getOIBarWidth = useCallback((oi: number, maxOIValue: number) => {
    const width = maxOIValue ? ((oi * 100) / maxOIValue) * 2 : 0;
    return width;
  }, []);

  const oiBarWidth = getOIBarWidth(Number(openInterest), maxOI);

  return <View css={css.oiBarCell} cssProps={{ isCall, width: oiBarWidth }} />;
};

export default observer(OptionChainOIBarCell);
